import { GeneralService } from './../services/general.service';
import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-odoo-pos-dev',
  templateUrl: './odoo-pos-dev.component.html',
  styleUrls: ['./odoo-pos-dev.component.css']
})
export class OdooPosDevComponent implements OnInit {

  
  constructor(private commonScriptComponent:CommonScriptComponent, private generalService:GeneralService) { }
  base_url = this.generalService.BASE_URL;

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/odoo-pos-dev/odoo-pos-dev.component.ts